import type { IAnalyticMetricShowing } from '../types/metric';
import type { ICurrencyRates } from '~/modules/shopify';
import type { DateTimeFilter } from '~/presentation/ui';

import { create } from 'zustand';

export type VariantMetricCache = Record<string, boolean>;

export interface AnalyticStoreState {
  metricShowing?: IAnalyticMetricShowing[];
  dateTimePicked?: DateTimeFilter;
  isShowModalAnalyticLayout: boolean;
  cachedVariants: VariantMetricCache;
  addFetchedVariant: (variantId: string) => void;
  isVariantFetched: (variantId: string) => boolean;
  setMetricShowing: (metricShowing: IAnalyticMetricShowing[]) => void;
  setDateTimePicked: (dateTimePicked: DateTimeFilter) => void;
  setIsShowModalAnalyticLayout: (isShowModalAnalyticLayout: boolean) => void;
  currencyRates?: ICurrencyRates;
  setCurrencyRates: (value: ICurrencyRates) => void;
}

export const useAnalyticStore = create<AnalyticStoreState>()((set, get) => ({
  metricShowing: undefined,
  dateTimePicked: undefined,
  isShowModalAnalyticLayout: false,
  cachedVariants: {},
  addFetchedVariant: (variantId) =>
    set((state) => ({
      cachedVariants: { ...state.cachedVariants, [variantId]: true },
    })),
  isVariantFetched: (variantId) => Boolean(get().cachedVariants[variantId]),
  setMetricShowing: (metricShowing: IAnalyticMetricShowing[]) => set({ metricShowing }),
  setDateTimePicked: (dateTimePicked: DateTimeFilter) => set({ dateTimePicked }),
  setIsShowModalAnalyticLayout: (isShowModalAnalyticLayout: boolean) =>
    set({ isShowModalAnalyticLayout }),

  currencyRates: undefined,
  setCurrencyRates: (value) => set({ currencyRates: value }),
}));
